import React, { useState, useEffect } from 'react';
import { Row, Input, Card, CardBody, Label, Col, FormGroup } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch } from 'react-redux';
import * as kanbanActions from '../store/kanban.action';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import DragDropApi from '../dragdrop.api';
import ModalLocalizacao from '../../../pages/arquivamento/tabs/Arquivamento/modais/Localizacao';

import IntlMessage from "../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Arquivamento(props) {
  const [destino, setDestino] = useState([]);
  const [destinos, setDestinos] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [lista, setLista] = useState([]);
  const dispatch = useDispatch();
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [localizacaoArquivamento, setLocalizacaoArquivamento] = useState('');

  const intl = useIntl()

  useEffect(() => {
    const data = props.data[Object.keys(props.data)[0]];
    if (data && data.length > 0) {
      reset();
      insertSelect(data);
    }
  }, [props.data]);

  useEffect(() => {
    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      props.destinos.findIndex(
        (x) => x.value === quadroKanbanEnum.CG_PENDENTES.id
      ) >= 0
    ) {
      const ndestinos = [...props.destinos];
      props.destinos.find(
        (x, i) =>
          x.value === quadroKanbanEnum.CG_PENDENTES.id && delete ndestinos[i]
      );
      setDestinos(ndestinos);
    } else {
      setDestinos(props.destinos);
    }
  }, [props.destinos]);

  useEffect(() => {
    const disabled = !selectGrid || destino.length === 0;
    dispatch(kanbanActions.atualizarMoverDisabled(disabled));
  }, [selectGrid, destino]);

  useEffect(() => {
    if (
      props.click &&
      (destino.label === `${intl.formatMessage({id:"general.materialArchiving.completed"}) }` ||
        destino.value === quadroKanbanEnum.AM_SOLICITADOS.id)
    ) {
      moverItens();
      props.onClick();
    } else if (
      props.click &&
      destino.value === quadroKanbanEnum.AM_ARQUIVADOS.id &&
      destino.label !== `${intl.formatMessage({id:"general.materialArchiving.completed"}) }`
    ) {
      setShowModalLocalizacao(!showModalLocalizacao);
      props.onClick();
    }
  }, [props.click]);

  function reset() {
    dispatch(kanbanActions.atualizarLamina([]));
    dispatch(kanbanActions.atualizarMoverDisabled(true));
    setLista([]);
    setSelectGrid(0);
    setDestino([]);
  }

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.data.itemId.toString()
        ) {
          if (
            document.getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document.getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            document.getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
  }

  function toggleCheckBox(checked) {
    let checkboxes = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document
          .getElementsByClassName('kanban-arquivamento-lote-table')[0]
          .getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function insertSelect(dados) {
    const novaLista = [];
    var primeiroQuadro = Object.keys(props.lista[0])[0];
    var segundoQuadro = Object.keys(props.lista[1])[0];
    if (
      primeiroQuadro === quadroKanbanEnum.AM_SOLICITADOS.id &&
      segundoQuadro === quadroKanbanEnum.AM_ARQUIVADOS.id &&
      props.lista[1].title.text !== `${intl.formatMessage({id:"general.materialArchiving.completed"}) }`
    ) {
      // eslint-disable-next-line array-callback-return
      dados.map((item, i) => {
        if (!item.isDragDisabled) {
          novaLista.push({
            itemId: item.id,
            identificacao: item.data.exame,
            material: item.data.descricaoMaterial,
            tecnico: item.data.nomeTecnico,

            select: (
              <input
                className="checkbox"
                name="checkbox"
                type="checkbox"
                id={item.id}
                onClick={(e) => selectItem(e)}
              />
            ),
          });
        }
      });
    } else {
      // eslint-disable-next-line array-callback-return
      dados.map((item, i) => {
        if (!item.isDragDisabled) {
          novaLista.push({
            itemId: item.id,
            identificacao: item.data.numero,
            material: item.data.material,
            tecnico: item.data.requisitante,

            select: (
              <input
                className="checkbox"
                name="checkbox"
                type="checkbox"
                id={item.id}
                onClick={(e) => selectItem(e)}
              />
            ),
          });
        }
      });
    }

    setLista(novaLista);
  }

  function getIconeStatus(value) {
    let icone, status;

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.AM_SOLICITADOS.id &&
      props.lista[1].title.text === 'Arquivado' &&
      value === quadroKanbanEnum.AM_ARQUIVADOS.id
    ) {
      status = quadroKanbanEnum.AM_ARQUIVADOS.status;
    }

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.AM_SOLICITADOS.id &&
      props.lista[1].title.text === 'Arquivados' &&
      value === quadroKanbanEnum.AM_SOLICITADOS.id
    ) {
      status = quadroKanbanEnum.AM_SOLICITADOS.status;
    }

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.RM_SOLICITADOS.id &&
      props.lista[1].title.text === `${intl.formatMessage({id:"general.materialArchiving.completed"}) }` &&
      value === quadroKanbanEnum.RM_CONCLUIDOS.id
    ) {
      status = quadroKanbanEnum.RM_CONCLUIDOS.status;
    }
    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.RM_SOLICITADOS.id &&
      props.lista[1].title.text === `${intl.formatMessage({id:"general.materialArchiving.completed"}) }` &&
      value === quadroKanbanEnum.RM_SOLICITADOS.id
    ) {
      status = quadroKanbanEnum.RM_SOLICITADOS.status;
    }

    return { icone, status };
  }

  function montarArquivamentoMateriais(itens) {
    let arquivamentos = [];
    for (let item of itens) {
      let arquivamento = item.id.split('_');
      const iconeStatus = getIconeStatus(destino.value);
      arquivamentos.push({
        arquivamentoId: +arquivamento[1],
        localizacao: localizacaoArquivamento,
        status: iconeStatus.status,
      });
    }
    return arquivamentos;
  }

  function montarRequisicaoMateriais(itens) {
    let arquivamentos = [];
    for (let item of itens) {
      let arquivamento = item.id.split('_');
      const iconeStatus = getIconeStatus(destino.value);
      arquivamentos.push({
        idRequisicao: +arquivamento[1],
        status: iconeStatus.status,
      });
    }
    return arquivamentos;
  }

  async function moverItens() {

    dispatch(commonActions.showFadeCarregando(true));

    const data = document
      .getElementsByClassName('kanban-arquivamento-lote-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');

    ///Requisição de material
    if (
      (props.lista[1].title.text === `${intl.formatMessage({id:"general.materialArchiving.completed"}) }` ||
        destino.value === quadroKanbanEnum.RM_SOLICITADOS.id)
      && props.lista[1].title.text !== 'Arquivados'
    ) {
      const payload = montarRequisicaoMateriais(data);
      const arquivamentos = { requisicoes: payload };
      const sendArquivamentos = await DragDropApi.requisicaoMateriais(
        arquivamentos
      );
      if (sendArquivamentos.success) {
        // dispatch(kanbanActions.atualizarNovasLaminas(true));
        dispatch(commonActions.showAlerta(
          'sucesso',
          `${intl.formatMessage({id:"dashboards.sample.itemsMovedSuccessfully"}) }`,
          1500
        ));
      }
      else
        dispatch(commonActions.showAlerta(
          'erro',
          `${intl.formatMessage({id:"dashboards.histology.unableMoveSelectedMaterials"}) }`,
          1500
        ));
    } else if (
      (destino.value === quadroKanbanEnum.AM_ARQUIVADOS.id ||
        destino.value === quadroKanbanEnum.AM_SOLICITADOS.id) &&
      props.lista[1].title.text !== `${intl.formatMessage({id:"general.materialArchiving.completed"}) }`
    ) {
      const payload = montarArquivamentoMateriais(data);
      const arquivamentos = { arquivamentos: payload };
      const sendArquivamentos = await DragDropApi.arquivarMaterias(
        arquivamentos
      );
      if (sendArquivamentos.success) {
        // dispatch(kanbanActions.atualizarNovasLaminas(true));        
        dispatch(commonActions.showAlerta(
          'sucesso',
          `${intl.formatMessage({id:"dashboards.sample.itemsMovedSuccessfully"}) }`,
          1500
        ));
      }
      else {
        dispatch(commonActions.showAlerta(
          'erro',
          `${intl.formatMessage({id:"dashboards.histology.unableMoveSelectedMaterials"}) }`,
          1500
        ));
      }
    }

    setShowModalLocalizacao(false);
    dispatch(commonActions.showModal(false));
    dispatch(commonActions.showFadeCarregando(false));
    document.getElementById('btnPesquisar').click();
    return dispatch(kanbanActions.atualizarModal(false));
  }

  return (
    <div>
      <ModalLocalizacao
        onModal={() => setShowModalLocalizacao(!showModalLocalizacao)}
        localizacaoArquivamento={localizacaoArquivamento}
        setLocalizacaoArquivamento={setLocalizacaoArquivamento}
        showModalLocalizacao={showModalLocalizacao}
        salvarLocalizacao={moverItens}
      />
      <Card>
        <CardBody>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label className="label-data" style={{ float: 'left' }}>
                  {`${intl.formatMessage({ id: "dashboards.cytology.origin" })}`}
                </Label>
                <Input
                  className="col-9"
                  value={props.data.title && props.data.title.text}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <div className="col-6">
              <Label className="label-data col-auto" style={{ float: 'left' }}>
                {`${intl.formatMessage({ id: "dashboards.cytology.destiny" })}`}
              </Label>
              <SelectComponent
                onChange={(e) => setDestino(e)}
                className="col-auto"
                value={destino}
                options={destinos}
                placeholder={`${intl.formatMessage({ id: "dashboards.cytology.selectDestiny" })}`}
              />
            </div>
          </Row>
          <br />
          <DataTable
            className="kanban-arquivamento-lote-table"
            onContextMenu={(e) => onChangeSelect(e)}
            value={lista}
            //pageLinkSize={20}
            responsive={true}
            selectionMode="single"
            style={{ height: '100%' }}
            columnResizeMode="expand"
            scrollable={true}
            //scrollHeight="50vh"
            scrollWidth="100%"
            //resizableColumns={listaDetalhes.length >= 1}
            //reorderableColumns={listaDetalhes.length >= 1}
            //rowsPerPageOptions={[10, 20, 50]}
            //rows={totalItensPage}
            lazy={true}
            paginator={false}
            //loading={carregando}
            //loadingIcon="mv-basico-menu_secundario"
            emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
          //footer={<RenderizarFooter total={totalItens} />}
          >
            <Column
              sortable={false}
              field="select"
              style={{ width: '25px', verticalAlign: 'middle' }}
              header={
                lista.length >= 1 && (
                  <input
                    type="checkbox"
                    id="selectMaterias"
                    name="selectMaterias"
                    onChange={(e) => {
                      toggleCheckBox(e.target.checked);
                    }}
                  />
                )
              }
            />

            <Column
              sortable={false}
              field="identificacao"
              style={{
                width: '150px',
                verticalAlign: 'middle',
              }}
              header={`${intl.formatMessage({ id: "general.materialArchiving.identification" })}`}
            />

            <Column
              sortable={false}
              field="material"
              style={{ width: '150px', verticalAlign: 'middle' }}
              header={`${intl.formatMessage({id: 'general.materialArchiving.material'})}`}
            />

            <Column
              sortable={false}
              field="tecnico"
              style={{ width: '180px', verticalAlign: 'middle' }}
              header={<IntlMessage id="dashboards.sample.technicianName" />}
            />
          </DataTable>
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/containers/arquivamento.js